import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontLeagueModuleTypes from '@/store/modules/frontDesk/league/interface';

const frontLeagueModule: Module<FrontLeagueModuleTypes, RootModuleTypes> = {
  namespaced: true,
  state: {
    activityJoinList: []
  },
  mutations: {
    activityJoinList(state, activityJoinList) {
      state.activityJoinList = activityJoinList;
    },
  },
  actions: {
      setActivityJoinList(context, activityJoinList) {
          return new Promise((resolve, reject) => {
            context.commit('activityJoinList', activityJoinList);
            resolve(activityJoinList);
        });
      },
      listBrandCategory(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/listBrandCategory", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      listJoinCategory(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/anon/listJoinCategory", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      listCompanyArea(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/listCompanyArea", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      pageActivityList(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/anon/pageActivityList", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      saveActivityApply(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/saveActivityApply", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
    },
    unloginSaveActivityApply(context, params) {
      return new Promise((resolve, reject) => {
          tool.post("/frontend/activity/anon/unloginSaveActivityApply", params).then(data => {
              if (data.status === 2000) {
                  resolve(data);
              }
              else {
                  reject(data);
              }
          });
      });
    },
    },
};

export default frontLeagueModule;